<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title
        h1.subheading {{ $t('labels.convertedStores') }}
      v-spacer
    v-card-text
      v-layout(row)
        v-autocomplete(
          :items="storeList"
          :label="$t('labels.searchStore')"
          item-text="value"
          item-value="data" 
          v-model="selectedStore")
        v-btn(color='info' @click="addLocation") add
    v-card-text.pt-0.convert-card
      v-data-table(:headers='headers', hide-actions
        :items='selectedStoreList',
        item-key="CSPID")
        template(slot='items', slot-scope='props')
          tr
            td.text-xs-left.pointer.small-td
              span
                v-btn(color="red" icon @click="deleteRow(props.item)")
                  v-icon(color="white") delete
              span {{ props.item.CSPID }}
            td.text-xs-left.pointer {{ props.item.businessName }}
            td.text-xs-left.pointer {{ props.item.businessPhone | USPhoneNumber }}
            

</template>

<script>
import leadService from '../service'
export default {
  props: ['lead'],
  data() {
    return {
      storeList: [],
      selectedStore: null,
      selectedStoreList: [],
      headers: [
        {
          text: this.$t("labels.cspID"),
          align: "left",
          sortable: true,
          value: "CSPID"
        },
        {
          text: this.$t("labels.storeName"),
          value: "businessName",
          sortable: true
        },
        {
          text: this.$t("labels.phoneNumber"),
          value: "businessPhone",
          sortable: true
        }
      ],
    }
  },
  created() {
    this.getActiveStore()
    this.getConvertedStores()
  },
  methods: {
    deleteRow(data) {
      let convertData = {
        leadID: null
      }
      return leadService.unConvertLead(data.storeID, convertData)
      .then(result => {
        this.getActiveStore()
        this.getConvertedStores()
      })
    },
    addLocation() {
      let found = false
      this.selectedStoreList.map(row => {
        if(this.selectedStore.storeID === row.storeID) {
          found = true
        }
      })
      if (!found) {
        if (this.selectedStore) {
          this.selectedStoreList.push(this.selectedStore)
          this.convertLead(this.selectedStore)
          this.selectedStore = null
        } 
      }else {
        this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          type: 'error',
          title: 'Location already exists in list'
        })
        this.selectedStore = null
      }
      
    },
    convertLead(data) {
      let convertData = {
        leadID: this.lead.id
      }
      return leadService.convertLead(data.storeID, convertData)
      .then(result => {
        this.getActiveStore()
      })
    },
    getActiveStore() {
      return leadService.leadStore()
      .then(result => {
        this.storeList = result.data
      })
    },
    getConvertedStores() {
      return leadService.convertedStores(this.lead.id)
      .then(result => {
        this.selectedStoreList = result.data
      })
    }
  }
}
</script>

<style scoped>
  .convert-card {
    max-height: 300px;
    overflow: auto;
  }
</style>